import { render, staticRenderFns } from "./TransferredOrdersTable.vue?vue&type=template&id=dc484980&scoped=true"
import script from "./TransferredOrdersTable.vue?vue&type=script&lang=ts"
export * from "./TransferredOrdersTable.vue?vue&type=script&lang=ts"
import style0 from "./TransferredOrdersTable.vue?vue&type=style&index=0&id=dc484980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc484980",
  null
  
)

export default component.exports